import React, { useState } from 'react';
import { CartDTO } from '../../../modules/cart/types';
import { Checkout } from './paymentCommit';
import { Cart } from './cartTable';

export const CartPage: React.FC = () => {
  const [orderStage, setOrderStage] = useState<'cart' | 'checkout'>('cart');
  const [checkoutItems, setCheckoutItems] = useState<CartDTO['order_items']>([]);
  const [tempAmounts, setTempAmounts] = useState<{ [key: string]: number | null }>({});

  const handleProceedToCheckout = (items: CartDTO['order_items']) => {
    setCheckoutItems(items);
    setOrderStage('checkout');
  };

  if (orderStage === 'checkout') {
    return (
      <Checkout
        checkoutItems={checkoutItems}
        tempAmounts={tempAmounts}
        onProceedToCheckout={() => setOrderStage('cart')}
      />
    );
  }

  return <Cart onProceedToCheckout={handleProceedToCheckout} />;
};
